// extracted by mini-css-extract-plugin
export default {"FacetHelp":"xr_a bhf_jh bhf_sy","FacetHelp__paragraph":"xr_b bhf_vr bhf_xe","FacetHelp__youtube":"xr_c"};